import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Fab } from '@material-ui/core';
import DoneIcon from '@material-ui/icons/Done';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

import styles from './styles.module.css';
import {
  rememberBoard,
  deleteChart,
} from '../../../events';
import * as actions from '../../../state';
import { selectLayout } from '../../../state';

function HeaderItem({
  board,
  chart,
}) {
  const dispatch = useDispatch();

  const layout = useSelector(selectLayout);
  const selectedChartId = useSelector((state) => state?.board?.selectedChartId);

  const editHeader = () => {
    dispatch(actions.editMode(true));
    dispatch(actions.showRightSidebar(true));

    dispatch(actions.selectedChartId(chart.id));
    dispatch(rememberBoard(board));

    /* attempt to scroll content container to top */
    setTimeout(() => { // put in a timeout so a render cycle can complete first
      try { // catch here because sometimes gridElement isn't found
        const gridElement = document.getElementById('content-container');
        gridElement.scrollTo(0, 0);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.debug(e);
      }
    }, 1);
  };

  const editDone = () => {
    dispatch(actions.showRightSidebar(false));
    dispatch(actions.selectedChartId(null));
  };

  const deleteHeader = () => {
    dispatch(actions.showRightSidebar(false));
    dispatch(actions.selectedChartId(null));
    dispatch(rememberBoard(board));
    dispatch(deleteChart(chart.id));
  };

  const classes = [styles.headerItem];
  if (layout.editMode) { classes.push(styles.editModeCard); }
  if (String(selectedChartId) === String(chart.id)) { classes.push(styles.editingHeaderItem); }

  return (
    <div className={classes.join(' ')} style={{ ...chart.properties }}>
      { String(selectedChartId) === String(chart.id)
        && (
          <div className={styles.floatingCardBtns}>
            <Fab className={styles.floatingDeleteBtn} onClick={deleteHeader}>
              <DeleteIcon />
            </Fab>

            <Fab className={styles.floatingDoneBtn} onClick={editDone}>
              <DoneIcon />
            </Fab>
          </div>
        )}
      <span className={styles.headerText}>
        {chart.name}
      </span>
      {layout.editMode && (
        <div className={styles.headerItemActions}>
          <EditIcon
            className={`header-item-action-btn ${styles.headerItemActionBtn}`}
            onClick={editHeader}
          />
          <DeleteIcon
            className={`header-item-action-btn ${styles.headerItemActionBtn}`}
            onClick={deleteHeader}
          />
        </div>
      )}
    </div>
  );
}

HeaderItem.propTypes = {
  board: PropTypes.shape({}).isRequired,
  chart: PropTypes.shape({}).isRequired,
};

export default HeaderItem;
